<script>
import { isEqual } from "lodash";
import { mapGetters } from "vuex";

export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    editable: Boolean,
    hasAdminRole: Boolean
  },
  components: {
    Field: () => import("@/components/input-v.vue")
  },
  data() {
    const fieldErrors = new Set();
    return {
      allBUs: [],
      fieldErrors,
      formData: {},
      isLoading: false,
      opts: {
        beneficiosEconomicosFuturo: [
          {
            value: "Geração de Receita"
          },
          {
            value: "Redução de Custo"
          }
        ],
        buOpts: [],
        destinosUso: [
          {
            value: "Interno"
          },
          {
            value: "Externo"
          }
        ],
        divisoes: [],
        emails: [],
        emails_demandantes: [],
        empresasBeneficiadas: [
          {
            value: "FIBX - Banco"
          },
          {
            value: "FIXP - Corretora"
          },
          {
            value: "NFSG - Seguradora"
          }
        ],
        formasSeparacao: [
          {
            value: "Alugar"
          },
          {
            value: "Vender"
          },
          {
            value: "Transferir"
          },
          {
            value: "Trocar"
          },
          {
            value: "Licenciar"
          }
        ],
        impactos: [
          {
            value: "Adição de Feature"
          },
          {
            value: "Automatização de Processos"
          },
          {
            value: "Evolução Incremental"
          },
          {
            value: "Plataforma Nova"
          },
          {
            value: "Produto Novo"
          }
        ],
        impactosFinanceiros: [
          {
            value: "Custo — Evitação (Cost Aoidance)"
          },
          {
            value: "Custo — Redução (Saving)"
          },
          {
            value: "Receita Incremental"
          },
          {
            value: "Receita Nova"
          }
        ],
        iniciativasArtefatosTecnologicos: [
          {
            value: "Automatização de Processos"
          },
          {
            value: "Evolução em Plataformas Internas"
          },
          {
            value: "Plataforma Nova"
          }
        ],
        participantes: [
          {
            value: "People"
          },
          {
            value: "No People"
          },
          {
            value: "People & No People"
          }
        ],
        substanciasFisicas: [
          {
            value: "Não possui"
          },
          {
            value: "Possui"
          }
        ],
        switchOpts: [
          {
            id: false,
            value: "Não"
          },
          {
            id: true,
            value: "Sim"
          }
        ],
        statusBP: []
      },
      validationMode: "save"
    };
  },
  computed: {
    ...mapGetters(["clientId", "selectedClient"]),
    fantasyName() {
      return this.selectedClient?.fantasia ?? "empresa";
    },
    fields() {
      const form = {
        businessPlan: [
          {
            key: "nome",
            name: "Nome da iniciativa:",
            type: this.$fieldTypes.TEXT,
            rules: [{ rule: "required" }],
            colSize: 12,
            editable: this.editable
          },
          {
            key: "status",
            name: "Status do Business Plan:",
            type: this.$fieldTypes.AUTOCOMPLETE,
            rel: { to: "statusBP", key: "id", name: "label" },
            hideInForm: this.isCreate,
            editable: false,
            colSize: 4
          },
          {
            key: "data_inicio",
            name: "Data de início:",
            type: this.$fieldTypes.DATE,
            hideInForm: this.isCreate,
            editable: false,
            colSize: 4
          },
          {
            key: "data_fim",
            name: "Data de término:",
            type: this.$fieldTypes.DATE,
            hideInForm: this.isCreate,
            editable: false,
            colSize: 4
          },
          {
            key: "diretoriaId",
            name: "Diretoria:",
            type: this.$fieldTypes.AUTOCOMPLETE,
            rel: { to: "divisoes", key: "id", name: "nome" },
            editable: this.editable,
            colSize: 6,
            onChange: this.divisionChanged
          },
          {
            key: "business_unit_ids",
            name: "BUs relacionadas a iniciativa:",
            type: this.$fieldTypes.AUTOCOMPLETE_MULTIPLE,
            rel: { to: "buOpts", key: "id", name: "nome" },
            placeholder: this.opts.buOpts.length
              ? "Selecione um ou mais BUs"
              : "Selecione uma diretoria",
            editable: this.editable && !!this.opts.buOpts.length,
            colSize: 6
          },
          {
            key: "non_people",
            name: "BP 100% Non People",
            type: this.$fieldTypes.SWITCH,
            rel: { to: "switchOpts", key: "id", name: "value" },
            editable: this.editable || this.hasAdminRole,
            defaultValue: false,
            colSize: 6
          }
        ],
        existenciaMercado: [
          {
            key: "ativo_produto_servico_semelhante",
            name:
              "Há produtos ou serviços semelhantes ao Ativo resultante da Iniciativa no mercado?",
            type: this.$fieldTypes.SWITCH,
            rel: { to: "switchOpts", key: "id", name: "value" },
            editable: this.editable,
            defaultValue: false
          },
          {
            key: "ativo_produto_servico_semelhante_desc",
            name:
              "Se sim, cite os principais (exemplos: corretoras, instituições financeiras):",
            type: this.$fieldTypes.TEXTAREA,
            editable: this.editable
          },
          {
            key: "mercado_comercializacao",
            name:
              "Há mercado para comercialização do ativo gerado pela iniciativa?",
            type: this.$fieldTypes.SWITCH,
            rel: { to: "switchOpts", key: "id", name: "value" },
            editable: this.editable,
            defaultValue: false
          },
          {
            key: "potenciais_consumidores",
            name:
              "Se houver, cite os potenciais usuários (exemplo: assessores, clientes, etc.):",
            type: this.$fieldTypes.TEXTAREA,
            editable: this.editable
          }
        ],
        identificavel: [
          {
            key: "ativo_forma_separacao",
            name:
              "No caso de intenção de separação do ativo pela empresa, qual seria a possível forma de destinação?",
            type: this.$fieldTypes.SELECT,
            rel: { to: "formasSeparacao", key: "value", name: "value" },
            colSize: 12,
            editable: this.editable
          }
        ],
        iniciativa: [
          {
            key: "iniciativa_escopo",
            name: "Descrever o que será desenvolvido no escopo da iniciativa:",
            type: this.$fieldTypes.TEXTAREA,
            colSize: 6,
            editable: this.editable
          },
          {
            key: "iniciativa_escopo_solucao",
            name:
              "Descrever qual o principal problema ou dificuldade operacional a iniciativa tenta solucionar:",
            type: this.$fieldTypes.TEXTAREA,
            colSize: 6,
            editable: this.editable
          },
          {
            key: "iniciativa_inovacoes",
            name:
              "Descrever como o processo ou serviço é hoje e como ficará após o desenvolvimento:",
            type: this.$fieldTypes.TEXTAREA,
            colSize: 6,
            editable: this.editable
          },
          {
            key: "iniciativa_riscos_barreiras",
            name:
              "Quais as barreiras e riscos atreladas a execução da iniciativa?",
            type: this.$fieldTypes.TEXTAREA,
            colSize: 6,
            editable: this.editable
          },
          {
            key: "iniciativa_relacoes_tecnologia",
            name:
              "Relação de tecnologias e o seu emprego na iniciativa (Exemplos: Banco de dados, linguagens de programação, serviços em nuvem, segurança, ambientes, entre outros):",
            type: this.$fieldTypes.TEXTAREA,
            colSize: 6,
            editable: this.editable
          },
          {
            key: "iniciativa_artefato_tecnologico",
            name: "Artefato tecnológico resultante da iniciativa:",
            type: this.$fieldTypes.SELECT,
            rel: {
              to: "iniciativasArtefatosTecnologicos",
              key: "value",
              name: "value"
            },
            colSize: 6,
            editable: this.editable
          }
        ],
        intencaoConcluir: [
          {
            key: "engenharia_valor",
            name: "A iniciativa passou por Engenharia de Valor?",
            type: this.$fieldTypes.SWITCH,
            rel: { to: "switchOpts", key: "id", name: "value" },
            editable: this.editable,
            defaultValue: false
          },
          {
            key: "relacao_id_epicos_portifolios",
            name:
              "Relação de ID(s) de Épico de Portfólios ou Épicos que devem ser considerados para acompanhamento de horas da iniciativa:",
            type: this.$fieldTypes.TEXTAREA,
            editable: this.editable
          }
        ],
        naoMonetario: [
          {
            key: "ativo_destinado_uso",
            name: "O Ativo será destinado para uso:",
            type: this.$fieldTypes.SELECT,
            rel: { to: "destinosUso", key: "value", name: "value" },
            editable: this.editable
          }
        ],
        recursoControlado: [
          {
            key: "ativo_controle",
            name: `O ativo gerado pelo projeto é de controle integral da ${this
              .fantasyName || "empresa"}?`,
            type: this.$fieldTypes.SWITCH,
            rel: { to: "switchOpts", key: "id", name: "value" },
            colSize: 12,
            editable: this.editable,
            defaultValue: false
          }
        ],
        responsaveis: [
          {
            key: "usuario_id",
            name: "Demandante da iniciativa:",
            type: this.$fieldTypes.AUTOCOMPLETE,
            rel: { to: "emails_demandantes", key: "id", name: "label" },
            colSize: 12,
            editable: this.editable,
            hideInForm: this.isCreate
          },
          {
            key: "lider_tecnologia",
            name: "Líder de Tecnologia da iniciativa:",
            type: this.$fieldTypes.AUTOCOMPLETE,
            rel: { to: "emails", key: "id", name: "label" },
            colSize: 12,
            editable: this.editable
          },
          {
            key: "lider_produto",
            name: "Líder de Produtos da iniciativa:",
            type: this.$fieldTypes.AUTOCOMPLETE,
            rel: { to: "emails", key: "id", name: "label" },
            colSize: 12,
            editable: this.editable
          },
          {
            key: "lider_negocio",
            name: "Líder de Negócios da iniciativa:",
            type: this.$fieldTypes.AUTOCOMPLETE,
            rel: { to: "emails", key: "id", name: "label" },
            colSize: 12,
            editable: this.editable
          },
          {
            key: "responsaveis_acompanhamento",
            name: "Responsáveis pelo acompanhamento da iniciativa:",
            type: this.$fieldTypes.AUTOCOMPLETE_MULTIPLE,
            rel: { to: "emails", key: "id", name: "label" },
            colSize: 12,
            editable: this.editable
          }
        ]
      };

      if (this.validationMode === "approve") {
        const optionalFieldKeys = ["responsaveis_acompanhamento"];

        if (!this.formData.ativo_produto_servico_semelhante) {
          optionalFieldKeys.push("ativo_produto_servico_semelhante_desc");
        }

        if (!this.formData.mercado_comercializacao) {
          optionalFieldKeys.push("potenciais_consumidores");
        }

        if (!this.formData.engenharia_valor) {
          optionalFieldKeys.push("relacao_id_epicos_portifolios");
        }

        Object.values(form).forEach(fields => {
          fields
            .filter(({ key }) => !optionalFieldKeys.includes(key))
            .forEach(field => {
              const rules = Array.isArray(field.rules) ? [...field.rules] : [];
              const isRequired = rules.some(({ rule }) => rule === "required");

              if (isRequired || field.type === this.$fieldTypes.SWITCH) {
                return;
              }

              rules.push({ rule: "required" });
              field.rules = Array.from(rules);
            });
        });
      }

      return form;
    },
    isCreate() {
      return this.$route.meta.mode === "create";
    },
    resource() {
      return this.apiResource("/v1/captacao/tipoRubricas");
    }
  },
  async created() {
    try {
      this.isLoading = true;
      await Promise.all([
        this.getEmails(),
        this.getBUs(),
        this.getEmailsDemandantes(),
        this.getDivisoes(),
        this.getStatusBP()
      ]);
      this.setInternalData(this.data);
      this.setBussinessUnit(this.formData);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    divisionChanged(divisaoId) {
      this.opts.buOpts = this.allBUs.filter(
        ({ divisao_id }) => divisao_id === divisaoId
      );
    },
    async getBUs() {
      try {
        const { get } = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/business-units/selecao`
        );
        const response = await get();

        if (Array.isArray(response)) {
          this.allBUs = response.sort();
          this.opts.buOpts = [];
          return response;
        }

        this.allBUs = [];
        this.opts.buOpts = [];
      } catch (error) {
        this.notify(error);
        this.allBUs = [];
        this.opts.buOpts = [];
      }
    },
    async getDivisoes() {
      try {
        const resource = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/business-units-divisao/selecao`
        );
        const response = await resource.get();
        this.opts.divisoes = response;
      } catch (error) {
        this.opts.divisoes = [];

        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    async getEmails() {
      try {
        const { get } = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/responsaveis/selecao`
        );
        const response = await get();

        if (Array.isArray(response)) {
          this.opts.emails = response.map(responsavel => ({
            ...responsavel,
            label: `${responsavel.nome} (${responsavel.email})`
          }));
          return;
        }

        this.opts.emails = [];
      } catch (error) {
        this.notify(error);
        this.opts.emails = [];
      }
    },
    async getEmailsDemandantes() {
      try {
        const { get } = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/business-plans/selecao-demandantes`
        );
        const response = await get();

        if (Array.isArray(response)) {
          this.opts.emails_demandantes = response.map(responsavel => ({
            ...responsavel,
            label: `${responsavel.nome} (${responsavel.email})`
          }));
          return;
        }

        this.opts.emails_demandantes = [];
      } catch (error) {
        this.notify(error);
        this.opts.emails_demandantes = [];
      }
    },
    async getStatusBP() {
      try {
        const { get } = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/business-plans/status`
        );
        const response = await get();

        if (Array.isArray(response)) {
          this.opts.statusBP = response;
          return;
        }

        this.opts.emails_demandantes = [];
      } catch (error) {
        this.notify(error);
        this.opts.emails_demandantes = [];
      }
    },
    onError(key, invalid) {
      if (invalid) {
        this.fieldErrors.add(key);
      } else {
        this.fieldErrors.delete(key);
      }

      this.$emit("error", this.fieldErrors.size);
    },
    setInternalData(value) {
      if (!value) {
        return;
      }

      this.formData = { ...value };
    },
    /** @method validate
     * @param {'approve' | 'save'} mode
     * @returns {boolean}
     */
    validate(mode = "save") {
      this.validationMode = mode;
      const fields = Object.values(this.fields).reduce(
        (acc, fields) => [...acc, ...fields],
        []
      );
      const invalidFields = fields.filter(
        ({ hideInForm, valid }) => !hideInForm && !!valid && !valid()
      );
      return invalidFields.length === 0;
    },
    setBussinessUnit(value) {
      if (Array.isArray(value.business_units) && value.business_units.length) {
        const [{ divisao_id }] = value.business_units;
        this.divisionChanged(divisao_id);
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler(value) {
        if (!isEqual(this.formData, value)) {
          this.setInternalData(value);
          this.setBussinessUnit(value);
        }
      }
    },
    formData: {
      deep: true,
      handler(value) {
        this.$emit("update:data", value);
      }
    }
  }
};
</script>

<template>
  <v-row class="pr-4">
    <Field
      v-for="(field, index) of fields.businessPlan"
      class="pl-4"
      :colSize="field.colSize"
      :hideInform="field.hideInForm"
      :key="`business-plan-${index}`"
      :label="field"
      :opts="opts"
      :valid.sync="field.valid"
      v-model="formData[field.key]"
      @input="$event => field.onChange && field.onChange($event)"
      @error="onError(field.key, $event)"
    ></Field>
    <v-col :cols="12">
      <h3>Informações da iniciativa</h3>
    </v-col>
    <Field
      v-for="(field, index) of fields.iniciativa"
      class="pl-4"
      :colSize="field.colSize"
      :key="`iniciativa-${index}`"
      :label="field"
      :opts="opts"
      :valid.sync="field.valid"
      v-model="formData[field.key]"
      @error="onError(field.key, $event)"
    ></Field>
    <v-col :cols="12">
      <h3>IAS38 - Framework</h3>
    </v-col>
    <v-col :cols="12">
      <h4>Recurso controlado</h4>
    </v-col>
    <Field
      v-for="(field, index) of fields.recursoControlado"
      class="pl-4"
      :colSize="field.colSize"
      :key="`recurso-controlado-${index}`"
      :label="field"
      :opts="opts"
      :valid.sync="field.valid"
      v-model="formData[field.key]"
      @error="onError(field.key, $event)"
    ></Field>
    <v-col :cols="12">
      <h4>Não-monetário</h4>
    </v-col>
    <Field
      v-for="(field, index) of fields.naoMonetario"
      class="pl-4"
      :colSize="field.colSize"
      :key="`nao-monetario-${index}`"
      :label="field"
      :opts="opts"
      :valid.sync="field.valid"
      v-model="formData[field.key]"
      @error="onError(field.key, $event)"
    ></Field>
    <v-col :cols="12">
      <h4>Identificável</h4>
    </v-col>
    <Field
      v-for="(field, index) of fields.identificavel"
      class="pl-4"
      :colSize="field.colSize"
      :key="`identificavel-${index}`"
      :label="field"
      :opts="opts"
      :valid.sync="field.valid"
      v-model="formData[field.key]"
      @error="onError(field.key, $event)"
    ></Field>
    <v-col :cols="12">
      <h3>IAS38 - CAPEX</h3>
    </v-col>
    <v-col :cols="12">
      <h4>Existência de mercado</h4>
    </v-col>
    <Field
      v-for="(field, index) of fields.existenciaMercado"
      class="pl-4"
      :colSize="field.colSize"
      :key="`existencia-mercado-${index}`"
      :label="field"
      :opts="opts"
      :valid.sync="field.valid"
      v-model="formData[field.key]"
      @error="onError(field.key, $event)"
    ></Field>
    <v-col :cols="12">
      <h4>Intenção de concluir</h4>
    </v-col>
    <Field
      v-for="(field, index) of fields.intencaoConcluir"
      class="pl-4"
      :colSize="field.colSize"
      :key="`intencao-concluir-${index}`"
      :label="field"
      :opts="opts"
      :valid.sync="field.valid"
      v-model="formData[field.key]"
      @error="onError(field.key, $event)"
    ></Field>
    <v-col :cols="12">
      <h3>Responsáveis</h3>
    </v-col>
    <template v-if="!isLoading">
      <Field
        v-for="(field, index) of fields.responsaveis"
        class="pl-4"
        :colSize="field.colSize"
        :hideInform="field.hideInForm"
        :key="`responsaveis-${index}`"
        :label="field"
        :opts="opts"
        :valid.sync="field.valid"
        v-model="formData[field.key]"
        @error="onError(field.key, $event)"
      ></Field>
    </template>
  </v-row>
</template>

<style lang="scss" scoped>
h3,
h4 {
  font: 600 0.875rem Poppins;
  margin-left: 0.75rem;
  padding-bottom: 0;
}

h3 {
  font-size: 1.25rem;
}

.textarea-field::v-deep {
  form.v-form {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .v-label-input + div {
    margin-top: auto;
  }
}

.switch-field::v-deep form {
  flex-direction: row;

  div:not(.v-label-input) {
    flex-grow: 0;
    margin-left: 0.125rem;
  }
}
</style>
